import type {FinishedSaveResponse, UUID} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';
import {ngAsync} from 'shared/utils/ng-@decorators';

export class SutorReportReferencesDataService {
    public static serviceName = 'sutorReportReferencesDataService';

    public static readonly ROUTE = 'records';
    public static readonly CREATE_FROM_FILES_ROUTE = 'create-from-files';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async createFondRecordsUsingFiles(files: File[], fondId: number): Promise<FinishedSaveResponse<UUID[]>> {
        const formData = new FormData();

        files.forEach((file) => formData.append('files', file));
        formData.append('fond', fondId.toString(10));

        return this.ajaxService.createRequest(`${SutorReportReferencesDataService.ROUTE}/${SutorReportReferencesDataService.CREATE_FROM_FILES_ROUTE}`)
            .withHeaders({'Content-Type': undefined}) // Browser will set Content-Type automatically
            .post(formData);
    }
}